"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_sound__active(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a3cd4868-1536-4afa-91d4-034b5885e232",
    x1: 127.05,
    y1: 29.14,
    x2: 127.05,
    y2: 167.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdbdbd"
  }))), /*#__PURE__*/React.createElement("title", null, "sound-active-hi"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "9a63aa4e-8521-478e-bc1e-d37b660588d8",
    "data-name": "Apps_ic"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.13,125.63H28.54a12.52,12.52,0,0,1-12.49-12.55V79.92A12.51,12.51,0,0,1,28.54,67.38H78.19l49.67-46a2.49,2.49,0,0,1,4.19,1.83V169.84a2.49,2.49,0,0,1-4.19,1.83l-49.67-46Z",
    transform: "translate(0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.19,125.63H28.54a12.52,12.52,0,0,1-12.49-12.55V79.92A12.51,12.51,0,0,1,28.54,67.38H78.19Z",
    transform: "translate(0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.86,21.33l-5.81,5.39V166.28l5.81,5.39a2.49,2.49,0,0,0,4.19-1.83V23.16A2.49,2.49,0,0,0,127.86,21.33Z",
    transform: "translate(0)",
    fill: "url(#a3cd4868-1536-4afa-91d4-034b5885e232)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "061c4e54-9a23-4468-a52b-75e5998c3953",
    "data-name": "77f18b41-157a-40ca-ab4d-ba994b0e9cf0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.73,130.06a2,2,0,0,1-1.43-.6,2,2,0,0,1,0-2.86,43.33,43.33,0,0,0,0-61.2,2,2,0,0,1,2.86-2.86,47.37,47.37,0,0,1,0,66.92A2,2,0,0,1,156.73,130.06Z",
    transform: "translate(0)",
    fill: "#e60000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "09d1ba22-32be-4b00-9a54-48d8584ffc3f",
    "data-name": "cdbd5f61-fd0a-4e50-ba06-a76e9b6374d3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.64,116.64a2,2,0,0,1,0-2.53l0,0a25.51,25.51,0,0,0,0-36,2,2,0,0,1,2.86-2.86,29.57,29.57,0,0,1,0,41.77l-.23.23-.3.15A1.87,1.87,0,0,1,144.64,116.64Z",
    transform: "translate(0)",
    fill: "#e60000"
  })))));
}

var _default = ic_sound__active;
exports.default = _default;